import { ExclusiveSelectionGroup as ExclusiveSelectionGroupComponent } from '@randstad-lean-mobile-factory/react-components-core';
import { FieldPath, FieldValues, useController } from 'react-hook-form';

import { ErrorMessage } from '../../ErrorMessage';

import { Props } from './ExclusiveSelectionGroup.types';

/**
 * @deprecated use `ExclusiveChipGroup` instead
 * @example import { ExclusiveChipGroup } from '@randstad-lean-mobile-factory/react-form-fields';
 *          import { ChipGroupItem } from '@randstad-lean-mobile-factory/react-components-core';
 *
 *          <ExclusiveChipGroup control={control} name="name">
 *            <ChipGroupItem value="0" disabled>item</ChipGroupItem>
 *            <ChipGroupItem value="1">item</ChipGroupItem>
 *          </ExclusiveChipGroup>
 */
export const ExclusiveSelectionGroup = <
  TFieldValues extends FieldValues,
  TValue,
  TFormValue,
  TName extends FieldPath<TFieldValues>,
>({
  name,
  control,
  defaultValue,
  getSelectedValue,
  getSelectedFormValue,
  formFieldClassName,
  ...exclusiveSelectionGroupProps
}: Props<TFieldValues, TValue, TFormValue, TName>) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
  });

  return (
    <div className={formFieldClassName}>
      <ExclusiveSelectionGroupComponent
        {...exclusiveSelectionGroupProps}
        selected={getSelectedValue(field.value as TFormValue)}
        setSelected={value => {
          field.onChange(getSelectedFormValue(value));
        }}
      />
      <ErrorMessage error={error} />
    </div>
  );
};
